module.exports = "<div class=\"loader\" *ngIf=\"show\">\r\n\t<div class=\"loading-img\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/app/shared/loader/loader.component.html
// module id = ../../../../../src/app/shared/loader/loader.component.html
// module chunks = 1